<template>
    <div class='page-main common'>
        <a-steps :current="current" class="common-step">
            <a-step v-for="item in steps" :key="item.title" :title="item.title" ></a-step>
        </a-steps>
        <div>
            <keep-alive><component ref="operatorForm" :is="steps[current].comp" :text="steps[current].text"></component></keep-alive>
        </div>
        <div class="model-footer-btns spaceCenter">
            <a-button v-if="current == 0" style="margin-left: 8px" class="btn-big" @click="goback">
                取消
            </a-button>
            <a-button v-if="current > 0 && current < steps.length - 1" style="margin-left: 8px" class="btn-big" @click="prev">
                上一步
            </a-button>
            <a-button v-if="current < steps.length - 2" type="primary" class="btn-big" @click="next">
                下一步
            </a-button>
            <a-button
                v-if="current == steps.length - 2"
                type="primary"
               
                class="btn-big"
                @click="success"
            >
                确认
            </a-button>
            <a-button
                v-if="current == steps.length - 1"
               
                class="btn-big"
                @click="goback"
            >
                返回认证管理
            </a-button>
        </div>
    </div>
</template>

<script>
import userModify from "@/components/steps/user-modify"
import adminModify from "@/components/steps/admin-modify"
import success from "@/components/steps/success"
export default {
    name:"operator-modify",
    components: {
        userModify,adminModify,success
    },
    data() {
        return {
            current:0,
            steps:[
                {
                    title: '身份验证',
                    comp:"userModify"
                },
                {
                    title: '设置管理员信息',
                    comp:"adminModify"
                },
                {
                    title: '提交成功',
                    comp:"success",
                    text:"管理员信息修改提交成功，请线下邮寄变更资料"
                },
            ]
        };
    },
    computed: {},
    methods: {
        next() {
            if(this.current == 0){ //身份验证
                this.$refs["operatorForm"].check().then(res => {
                    this.current++;
                }).catch(err => {
                    console.log(err);
                });
            }
        },
        prev() {
            this.current--;
        },
        success(){
            this.$refs["operatorForm"].check().then(res => {
                this.current++;
            }).catch(err => {
                console.log(err);
            });
        },
        goback(){
            this.$router.go(-1);
        }
    },
    created() {},
    watch: {}
}
</script>
<style scoped>
    .common-step{
        width: 70%;
        margin:30px auto;
    }
</style>


// WEBPACK FOOTER //
// src/pages/security/vertify/operator-modify.vue